import { IconWrapper } from '../runtime';
export default IconWrapper('move', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 10.9997V11.7497C1.75 12.5782 2.42157 13.2497 3.25 13.2497H12.75C13.5784 13.2497 14.25 12.5782 14.25 11.7497V4.74973C14.25 3.9213 13.5784 3.24973 12.75 3.24973H8.5L6.58 1.80973C6.52807 1.77078 6.46491 1.74973 6.4 1.74973H3.25C2.42157 1.74973 1.75 2.4213 1.75 3.24973V5.99973",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.75 8.49976H8.5M8.5 8.49976L6.5 6.5M8.5 8.49976L6.5 10.5",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});